import { TEpic } from 'Redux/Config';
import Actions from 'Redux/Actions';
import { ofType } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { RequestApi } from 'utils/RequestApi';
import { StripeSetupIntentDocument, StripeSetupIntentQuery } from 'api/graphql';
import { logError } from 'utils/logError';

export const stripeSetupIntentRequestEpic: TEpic = (action$) =>
  action$.pipe(
    ofType(Actions.stripeSetupIntentRequest.type),
    mergeMap(() =>
      from(RequestApi.query<StripeSetupIntentQuery>(StripeSetupIntentDocument)).pipe(
        mergeMap(({ data }) => {
          return of(Actions.stripeSetupIntentSuccess({ clientSecret: data.stripeSetupIntent.clientSecret }));
        }),
        catchError((error) => {
          logError(error);
          return of(Actions.stripeSetupIntentFailure({ error }));
        }),
      ),
    ),
  );
